<template>
  <div class="app-offline">
    <img :src="logo" alt="Prefeitura de Anastácio" class="app-offline__logo" />
    <p class="app-offline__text">{{ mensagem }}</p>
  </div>
</template>

<script>
import logo from "@/assets/logos/brasao.png";

export default {
  name: "AppOffline",
  props: {
    mensagem: {
      type: String,
      default:
        "Aplicação temporariamente indisponível. Tente novamente mais tarde.",
    },
  },
  data() {
    return {
      logo,
    };
  },
};
</script>

<style scoped>
.app-offline {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 24px;
  box-sizing: border-box;
  text-align: center;
}

.app-offline__logo {
  max-width: 180px;
  width: 100%;
  height: auto;
  margin-bottom: 24px;
}

.app-offline__text {
  max-width: 480px;
  margin: 0;
  color: #333;
  font-size: 1.125rem;
  line-height: 1.5;
  white-space: pre-wrap;
}
</style>
